<template>
  <v-container id="data-table-guias" class="py-0 px-2">
    <v-row>
      <v-col class="text-left px-0 py-6" cols="6">
        <h1 style="color: #430f4a">Outras despesas</h1>
      </v-col>
      <v-col class="text-right px-1" cols="6">
        <v-spacer></v-spacer>
        <v-btn
          height="30px"
          class="ml-3"
          small
          color="primary"
          depressed
          outlined
          @click="showopen()"
        >
          critícas
        </v-btn>
        <v-btn
          height="30px"
          class="ml-3"
          small
          color="primary"
          depressed
          outlined
          @click="deleteItems('outros')"
        >
          excluir despesa
        </v-btn>
      </v-col>
      <v-col class="px-0 py-0" cols="12">
        <v-data-table
          v-model="select"
          :headers="header"
          :items="list"
          :items-per-page="itemsPerPage"
          :page.sync="page"
          hide-default-footer
          :class="['lotesListTable', !versaoMaior ?'columnsDisabled' :'']"
          ref="outrosListTable"
          min="-1"
          max="15"
          show-select
          dense
          @click:row="selectLine"
          @page-count="pageCount = parseInt($event, 10)"
          @toggle-select-all="selecionaTodos"
          @item-selected="selecaoUnica"
        >
          <template v-slot:item.selected="{ item }">
            <v-simple-checkbox v-model="item.selected"></v-simple-checkbox>
          </template>

          <template v-slot:item.dataExecucao="{ item }">
            <span
              v-if="item.id != id_list"
              >{{ item.dataExecucao | formatDate }}
            </span>
            <v-menu
              v-else
              ref="dt"
              v-model="dt"
              :close-on-content-click="true"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="item.dateFormatted"
                  dense
                  v-mask="'##/##/####'"
                  format="DD/MM/YYYY"
                  placeholder="DD/MM/YYYY"
                  label
                  outlined
                  style="
                    font-size: 12px;
                    height: 32px;
                    margin: 8px 0px 8px;
                    width: 105px;
                  "
                  v-bind="attrs"
                  v-on="on"
                  append-icon="mdi-calendar-blank"
                  @blur="item.dataExecucao = parseDate(item.dateFormatted)"
                  @change="marcarLinha(item, 'outrosListTable')"
                  :rules="[formRules.typeDateFormated]"
                ></v-text-field>
              </template>
              <v-date-picker
                color="primary"
                v-model="item.dataExecucao"
                @input="item.dateFormatted = formatDate(item.dataExecucao)"
                no-title
                scrollable
              ></v-date-picker>
            </v-menu>
          </template>

          <template v-slot:item.codigoTabela="{ item }">
            <div class="tabela-info"
              v-if="item.id != id_list"
              style="min-width: 150px; max-width: 150px;"
              >{{tabela = dominiosList[getListIndex('dm_tabela')].valores.filter(el => el.valor == item.codigoTabela).map(el => el.descricao)[0]}}
            </div>
            <v-select
              v-else
              v-model="item.codigoTabela"
              :menu-props="{ bottom: true, offsetY: true }"
              dense
              :items="dominiosList[getListIndex('dm_tabela')].valores"
              item-text="descricao"
              item-value="valor"
              outlined
              class="pa-0"
              style="font-size:13px;height:30px; min-width: 150px; max-width: 150px;"
              @change="marcarLinha(item, 'outrosListTable')"
            ></v-select>
          </template>

          <template v-slot:item.codigoProcedimento="{ item }">
            <span
              v-if="item.id != id_list"
              >{{ item.codigoProcedimento }}
            </span>
            <v-text-field
              v-else
              v-model="item.codigoProcedimento"
              outlined
              dense
              class="pa-0"
              style="font-size: 13px; height: 32px; margin: 8px 0px 8px"
              @change="marcarLinha(item, 'outrosListTable')"
            ></v-text-field>
          </template>

          <template v-slot:item.sequencialItem="{ item }">
            <span
              v-if="item.id != id_list"
              >{{ item.sequencialItem }}
            </span>
            <v-text-field
              v-else
              v-model="item.sequencialItem"
              outlined
              dense
              class="pa-0"
              style="
                font-size: 13px;
                height: 32px;
                margin: 8px 0px 8px;
                min-width: 60px;
              "
              maxlength="4"
              :rules="[formRules.typeInteger]"
              @change="marcarLinha(item, 'outrosListTable')"
            ></v-text-field>
          </template>

          <template v-slot:item.itemVinculado="{ item }">
            <span
              v-if="item.id != id_list"
              :class="[!hasSeqItem(item.itemVinculado) ?'' :'not-exist']"
              >{{ item.itemVinculado }}
              <v-tooltip bottom v-if="hasSeqItem(item.itemVinculado)">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" class="pa-0">
                    <v-icon 
                      style="font-size: 10px !important;" 
                      color="error"
                    >fa-exclamation-triangle
                    </v-icon>
                  </span>
                </template>
                <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
                  Esta sequencial de item não existe nos procedimentos 
                </span>
              </v-tooltip>
              
            </span>
            <v-select
              v-else
              v-model="item.itemVinculado"
              :menu-props="{ bottom: true, offsetY: true }"
              dense
              solo
              flat
              :label="item.itemVinculado"
              :items="seqItem"
              item-text="descricao"
              item-value="valor"
              outlined
              class="pa-0"
              style="font-size:13px;height:30px;margin: 8px 0px 8px;max-width: 100px;"
              @change="marcarLinha(item, 'outrosListTable')"
            ></v-select>
          </template>

          <template v-slot:item.descricaoProcedimento="{ item }">
            <span
              v-if="item.id != id_list"
              >{{ item.descricaoProcedimento }}
            </span>
            <v-text-field
              v-else
              v-model="item.descricaoProcedimento"
              outlined
              dense
              class="pa-0"
              style="font-size: 13px; height: 32px; margin: 8px 0px 8px"
              @change="marcarLinha(item, 'outrosListTable')"
            ></v-text-field>
          </template>

          <template v-slot:item.quantidadeExecutada="{ item }">
            <span
              v-if="item.id != id_list"
              >{{ item.quantidadeExecutada }}
            </span>
            <v-text-field
              v-else
              v-model="item.quantidadeExecutada"
              @input="item.valorTotal = Number(item.valorUnitario * item.quantidadeExecutada).toFixed(2); updateInfo()"
              outlined
              dense
              class="pa-0"
              style="
                font-size: 13px;
                height: 32px;
                margin: 8px 0px 8px;
                min-width: 60px;
              "
              maxlength="3"
              :rules="[formRules.typeInteger]"
              @change="marcarLinha(item, 'outrosListTable')"
            ></v-text-field>
          </template>

          <template v-slot:item.valorUnitario="{ item }">
            <span
              v-if="item.id != id_list"
              >{{ item.valorUnitario | formatPrice }}
            </span>
            <v-text-field
              v-else
              v-model.lazy="valor"
              v-money="money"
              outlined
              dense
              style="font-size: 13px; height: 32px; margin: 8px 0px 8px"
              @input="
                item.valorUnitario = valor
                  ? parseFloat(valor.replaceAll('.', '').replaceAll(',', '.'))
                  : null; item.valorTotal = Number(item.valorUnitario * item.quantidadeExecutada).toFixed(2); updateInfo()
              "
              :rules="[formRules.typeNumber]"
              @change="marcarLinha(item, 'outrosListTable')"
            />
          </template>
          <template v-slot:item.valorTotal="{ item }">
            {{ item.valorTotal | formatPrice }}
          </template>
        </v-data-table>
      </v-col>
      <v-col class="pa-1" cols="4"></v-col>
      <v-col class="pa-1" cols="4">
        <v-pagination
          class="no-box-shadow"
          v-model="page"
          :length="pageCount"
        ></v-pagination>
      </v-col>
      <v-col class="pa-1" cols="4">
        <p class="text-right mt-1 mb-2" style="font-size: 15px" v-if="valorTotal!=undefined">
          <b>Total (R$): {{valorTotal | formatPrice}}</b>
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import { VMoney } from "v-money";
import { mapState } from "vuex"
export default {
  directives: { money: VMoney },
  data() {
    return {
      select: [],
      selectedOutros: [],
      dateFormatted: null,
      date: null,
      dt: false,
      id_list: null,
      valor: null,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false,
      },
      tabela: null,
      header: [
        { text: "Data", align: "date" ,value: "dataExecucao", sortable: false },
        { text: "Tabela", width: "1px" , align:"center", value: "codigoTabela", sortable: false, },
        { text: "Código do Procedimento", value: "codigoProcedimento", sortable: false },
        { text: "Seq. do item", align:"center" , value: "sequencialItem", sortable: false },
        { text: "Item Vinculado", align:"center" , width: "1px" , value: "itemVinculado", sortable: false },
        { text: "Descrição", value: "descricaoProcedimento", sortable: false },
        { text: "Quant.", align:"center",value: "quantidadeExecutada", sortable: false },
        { text: "Valor unitário (R$)", width: "80px" , align:"end",value: "valorUnitario", sortable: false },
        { text: "Valor total (R$)", align:"end",value: "valorTotal", sortable: false },
      ],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  computed: {
    ...mapState({
      formRules: state => state.formRules
    }),
  },
  filters: {
    formatDate(date) {
      return moment(date).format("L");
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  methods: {
    hasSeqItem(itemVinculado){
      if(itemVinculado=="" || itemVinculado==null ){
        return false
      } else {
        let seqItemValues = this.seqItem.map(el=> el.valor)
        return !seqItemValues.includes(itemVinculado)
      }

    },
    selectLine(item) {
      this.id_list = item.id
      this.date = item.dataExecucao
      if (item.valorUnitario) {
        this.valor = (item.valorUnitario / 1).toFixed(2).toString().replace(".", ",");
        this.valor = this.valor.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    selecionaTodos(selection) {
      if (selection.value) {
        this.selectedOutros = [...selection.items];
      } else {
        this.selectedOutros = [];
      }
    },
    selecaoUnica(selection) {
      if (selection.value) {
        this.selectedOutros.push(selection.item);
      } else {
        let ind = this.selectedOutros.findIndex(
          (item) => item == selection.item
        );
        this.selectedOutros.splice(ind, 1);
      }
    },
    marcarLinha(item, table) {
      let index = this.list.findIndex(el=> el.id == item.id)
      this.$refs[table].$el.getElementsByTagName('tbody')[0].getElementsByTagName('tr')[index].setAttribute('class', 'active')
    },
  },
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(val);
    },
    selectedOutros(item) {
      this.selected(item, 'outros')
    },
    cleanSelect(val) {
      this.select = val
      this.id_list = null
      this.page = 1
      this.$refs['outrosListTable'].$el.querySelectorAll('tr').forEach(el =>el.removeAttribute('class', 'active'))
    },
  },
  props: {
    list: Array,
    valorTotal: Number,
    formatDate: Function,
    formRules: Object,
    parseDate: Function,
    selected: Function,
    cleanSelect: Array,
    deleteItems: Function,
    showopen: Function,
    updateInfo: Function,
    dominiosList: Array,
    getListIndex: Function,
    seqItem: Array,
    versaoMaior: Boolean
  },
};
</script>

<style>
.not-exist {
  color: #8f2c11;
}
.v-messages__message {
  font-size: 10px;
}
</style>